(function () {
  var TEST_NAME = 'pdp-features-reorder';

  function applyAbTestFromUrl(testName) {
    var raw = new URLSearchParams(window.location.search).get(testName);
    if (!raw) return;
    var value = raw.toUpperCase();
    if (value !== 'A' && value !== 'B' && value !== 'C') return;
    document.body.setAttribute('data-' + testName, value);
  }

  function applyVariantBAccordions() {
    if (document.body.getAttribute('data-' + TEST_NAME) !== 'B') return;

    var features = document.querySelectorAll(
      '.product__meta__accordions [data-index="pdp-desktop-accordion-features"]',
    );
    if (!features.length) return;

    features.forEach(function (el) {
      el.open = true;
    });

    document
      .querySelectorAll('.product__meta__accordions [data-index="pdp-desktop-accordion-description"]')
      .forEach(function (el) {
        el.open = false;
      });
  }

  function applyVariantBCarousel() {
    if (document.body.getAttribute('data-' + TEST_NAME) !== 'B') return;
    if (window.innerWidth > 449) return;

    document.querySelectorAll('.products-slider__section .swiper').forEach(function (el) {
      if (!el.swiper || el.swiper.params.slidesPerView === 1.5) return;
      el.swiper.params.slidesPerView = 1.5;
      el.swiper.update();
    });
  }

  function applyVariantB() {
    applyVariantBAccordions();
    applyVariantBCarousel();
  }

  applyAbTestFromUrl(TEST_NAME);
  applyVariantB();

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(applyVariantB).observe(document.body, {
      attributes: true,
      attributeFilter: ['data-' + TEST_NAME],
    });

    var carouselTimer;
    document.querySelectorAll('.products-slider__section').forEach(function (section) {
      new MutationObserver(function () {
        clearTimeout(carouselTimer);
        carouselTimer = setTimeout(applyVariantBCarousel, 50);
      }).observe(section, {
        childList: true,
        subtree: true,
      });
    });
  }
})();
